import React from 'react'
import { designTokens } from '@/utils/design-tokens'
import type { BusinessDetailFieldInfo } from '@/api/generated/models/BusinessDetailFieldInfo'

interface BusinessDetailFieldsProps {
  detailFields: BusinessDetailFieldInfo[]
  fieldValues: Record<string, string>
  onFieldChange: (fieldId: string, value: string) => void
  isLoading?: boolean
  error?: string | null
}

const BusinessDetailFields: React.FC<BusinessDetailFieldsProps> = ({
  detailFields,
  fieldValues,
  onFieldChange,
  isLoading = false,
  error
}) => {
  if (isLoading) {
    return (
      <div style={{
        padding: '16px',
        textAlign: 'center',
        color: designTokens.colors.gray[4]
      }}>
        상세 정보 필드를 불러오는 중...
      </div>
    )
  }

  if (error) {
    return (
      <div style={{
        padding: '16px',
        textAlign: 'center',
        color: designTokens.colors.error.DEFAULT
      }}>
        {error}
      </div>
    )
  }

  if (!detailFields || detailFields.length === 0) {
    return (
      <div style={{
        padding: '16px',
        textAlign: 'center',
        color: designTokens.colors.gray[4]
      }}>
        사용 가능한 상세 정보 필드가 없습니다.
      </div>
    )
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
      {detailFields.map(field => {
        const value = fieldValues[field.id] || ''

        return (
          <div key={field.id} style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
            <label style={{
              fontFamily: designTokens.typography.fontFamily.sans[0],
              fontSize: designTokens.typography.fontSize['body-medium'][0],
              fontWeight: 600,
              color: designTokens.colors.gray[6]
            }}>
              {field.name}
            </label>
            <textarea
              value={value}
              onChange={(e) => onFieldChange(field.id, e.target.value)}
              placeholder="내용을 입력해주세요"
              rows={4}
              style={{
                width: '100%',
                padding: '10px 12px',
                border: `1px solid ${designTokens.colors.gray[2]}`,
                borderRadius: '6px',
                fontFamily: designTokens.typography.fontFamily.sans[0],
                fontSize: designTokens.typography.fontSize['body-medium'][0],
                color: designTokens.colors.gray[6],
                backgroundColor: designTokens.colors.white,
                resize: 'vertical' as const
              }}
            />
          </div>
        )
      })}
    </div>
  )
}

export default BusinessDetailFields